export default [
  {
    path: '/produtoGrade/',
    name: 'produtoGrade',
    component: () => import('../views/ProdutoGradeView.vue'),
    redirect: { name: 'produtoGrade-listar' },
    children: [
      {
        path: 'welcome',
        name: 'produtoGrade-listar',
        meta: { title: 'Grade de produtos' },
        component: () => import('../views/ProdutoGradeWelcomeView.vue'),
      },
      {
        path: 'add',
        name: 'produtoGrade-cadastrar',
        meta: { title: 'Grade de produtos cadastrar' },
        component: () => import('../views/ProdutoGradeFormView.vue'),
      },
      {
        path: ':id',
        name: 'produtoGrade-editar',
        meta: { title: 'Grade de produtos editar' },
        component: () => import('../views/ProdutoGradeFormView.vue'),
      },
    ],
  },
];
